// extracted by mini-css-extract-plugin
export default {"root":"EditUserCounterForm_root__CEnA3","input":"EditUserCounterForm_input__zarMx"};